import { object, string, ref } from "yup";
import {
  firstNameMinLength,
  firstNameMaxLength,
  lastNameMinLength,
  lastNameMaxLength,
  loginMinLength,
  loginMaxLength,
} from "@framework/constants";
import { UserGroup } from "@framework/types";
import { createPasswordValidationSchema, IPasswordPolicy } from "@framework/yup-rules";

const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

const allowedUserGroups = Object.values(UserGroup)
  .filter((v): v is number => typeof v === "number" && v !== UserGroup.ADMINISTRATOR)
  .map(String);

export const createUserValidationSchema = (policy: IPasswordPolicy) =>
  object().shape({
    name: string()
      .min(firstNameMinLength, "form.validations.tooShort")
      .max(firstNameMaxLength, "form.validations.tooLong")
      .required("form.validations.valueMissing"),
    surName: string()
      .min(lastNameMinLength, "form.validations.tooShort")
      .max(lastNameMaxLength, "form.validations.tooLong")
      .required("form.validations.valueMissing"),
    email: string()
      .nullable()
      .notRequired()
      .matches(emailRegex, { message: "form.validations.patternMismatch", excludeEmptyString: true }),
    login: string()
      .min(loginMinLength, "form.validations.tooShort")
      .max(loginMaxLength, "form.validations.tooLong")
      .required("form.validations.valueMissing"),
    userGroup: string()
      .oneOf([...allowedUserGroups, ""], "form.validations.invalidValue")
      .required("form.validations.valueMissing"),
    password: createPasswordValidationSchema(policy),
    webKey: string().required("form.validations.valueMissing"),
  });

export const createChangePasswordValidationSchema = (policy: IPasswordPolicy) =>
  object().shape({
    newPassword: createPasswordValidationSchema(policy),
    confirmPassword: string()
      .required("form.validations.valueMissing")
      .oneOf([ref("newPassword")], "form.validations.passwordsMustMatch"),
  });
